export default __webpack_public_path__ + "locales/hy-AM/Profile.json?hash=a20e7389dfa80306142adc04297a52fc";